export function changeDocumentTitle(documentTitle?: string) {
  document.title = documentTitle || document.title || '';
}
